import React, { useState, CSSProperties, useEffect } from "react";
import logo from '../../../assets/images/logo.png'
import { API_BASE_URL } from "helpers/api/apiServices";
import { sendVisitLog } from "helpers/visitLogger";


const Cookies = require("js-cookie");

const CookiesDemo = () => {
    const [isCookieSet, setCookie] = useState<boolean>(!!Cookies.get("cookieConsent"));

    useEffect(() => {
        if (!isCookieSet) {
            const currentPage = window.location.href;
            Cookies.set("lastPageVisited", currentPage, { expires: 1 });
        }
    }, [isCookieSet]);




    const handleAcceptCookies = async () => {
        try {
            const res = await fetch("https://ipapi.co/json/");
            const data = await res.json();
            console.log('data', data);

            const country = data.country_name || "Unknown";
            const state = data.region || "Unknown";
            const city = data.city || "Unknown";

            // Save country + state
            localStorage.setItem("userCountry", country);
            localStorage.setItem("userState", state);
            localStorage.setItem("userCity", city);

            Cookies.set("userCountry", country, { expires: 7 });
            Cookies.set("userState", state, { expires: 7 });
            Cookies.set("userCity", city, { expires: 7 });

            const enhancedGeoData = {
                country: country,
                state: state,       // FIXED (use region)
                city: city,
                postalCode: data.postal,
                latitude: data.latitude,
                longitude: data.longitude,
                IPv4: data.ip
            };

            Cookies.set("geoData", JSON.stringify(enhancedGeoData), { expires: 7 });
            localStorage.setItem("geoData", JSON.stringify(enhancedGeoData));

        } catch (err) {
            console.log("Country fetch failed", err);
        }

        Cookies.set("cookieConsent", "true", { expires: 1 });
        Cookies.set("lastPageVisited", window.location.href, { expires: 1 });

        await sendVisitLog(window.location.href);

        setCookie(true);
        window.location.reload();
    };


    const handleAcceptCookiesLocation = async () => {
        try {
            const res = await fetch("https://geolocation-db.com/json/");
            const data = await res.json();

            const enhancedGeoData = {
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state,
                city: data.city,
                postalCode: data.postal,
                latitude: data.latitude,
                longitude: data.longitude,
                IPv4: data.IPv4,
                ISP: data.ISP,
                asn: data.asn
            };

            Cookies.set("geoData", JSON.stringify(enhancedGeoData), { expires: 7 });
            localStorage.setItem("geoData", JSON.stringify(enhancedGeoData));

        } catch (err) {
            console.log("Enhanced geolocation fetch failed", err);
        }
    };

    const handleRejectCookies = () => {
        Cookies.set("cookieConsent", "false", { expires: 1 });
        sendVisitLog(window.location.href);
        setCookie(true); // close popup immediately
    };

    return (
        <>
            {!isCookieSet && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <view>
                            <img src={logo} alt="logo" height="30" className="align-self-center" />
                        </view>

                        <h2 style={styles.title}>Our website uses cookies</h2>


                        We and selected third parties use cookies or similar technologies for technical purposes and, with your consent, for other purposes as specified in the{" "}
                        <a href="/cookie-policy" style={styles.link}>cookie policy</a>.
                        <br />
                        Use the "Accept" button to consent. Use the "Reject" button to continue without accepting.


                        <div style={styles.actions}>
                            <button style={styles.acceptButton} onClick={handleAcceptCookies}>
                                Accept All
                            </button>
                            <button style={styles.rejectButton} onClick={handleRejectCookies}>
                                Reject All
                            </button>
                        </div>

                        <button style={styles.linkButton}>Cookie Preferences</button>
                    </div>
                </div>
            )}
        </>
    );
};

const styles: { [key: string]: CSSProperties } = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
    },
    modal: {
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "16px",
        maxWidth: "600px",
        width: "90%",
        boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
        textAlign: "left",
        animation: "fadeIn 0.3s ease-in-out",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "15px",
        color: "#0d1b2a",
        marginTop: '15px'
    },
    text: {
        fontSize: "15px",
        lineHeight: "1.6",
        marginBottom: "20px",
        color: "#333",
    },
    actions: {
        display: "flex",
        gap: "15px",
        marginBottom: "15px",
        marginTop: "16px"
    },
    acceptButton: {
        backgroundColor: "#2e7d32",
        color: "white",
        border: "none",
        padding: "12px 24px",
        borderRadius: "30px",
        fontWeight: "bold",
        cursor: "pointer",
        flex: 1,
    },
    rejectButton: {
        backgroundColor: "white",
        color: "#333",
        border: "2px solid #ccc",
        padding: "12px 24px",
        borderRadius: "30px",
        fontWeight: "bold",
        cursor: "pointer",
        flex: 1,
    },
    linkButton: {
        background: "none",
        border: "none",
        color: "#888",
        textDecoration: "underline",
        cursor: "pointer",
        fontSize: "14px",
        alignSelf: "flex-start",
    },
};

export default CookiesDemo;
